class CustomDropdown extends HTMLElement {
  constructor() {
    super();
    this.selectElement = this.querySelector('select');
    this.button = this.querySelector('button');
    this.optionsList = this.querySelector('ul');
    this.valueDisplay = this.button.querySelector('span');

    if (!this.selectElement || !this.button || !this.optionsList) return;

    this.selectElement.style.display = 'none';

    this.addEventListener('click', this.handleClick.bind(this));
    
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
    
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        this.button.focus();
      }
    });
  }

  handleClick(event) {
    const target = event.target;

    if (target.closest('button') === this.button) {
      this.toggle(event);
    }

    const option = target.closest('.variant-option__select-option');
    if (option && !option.classList.contains('disabled')) {
      this.selectOption(option);
    }
  }

  toggle(event) {
    event.stopPropagation();
    const isHidden = this.optionsList.style.display === 'none' || !this.optionsList.style.display;
    if (isHidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.optionsList.style.display = 'block';
    this.button.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.optionsList.style.display = 'none';
    this.button.setAttribute('aria-expanded', 'false');
  }

  selectOption(listItem) {
    const selectedIndex = parseInt(listItem.dataset.index, 10);
    
    if (this.selectElement.selectedIndex === selectedIndex) {
      this.close();
      return;
    }

    this.selectElement.selectedIndex = selectedIndex;
    this.valueDisplay.textContent = listItem.textContent.trim();

    if (this.optionsList.querySelector('.selected')) {
      this.optionsList.querySelector('.selected').classList.remove('selected');
    }
    listItem.classList.add('selected');

    this.close();

    const changeEvent = new Event('change', { bubbles: true });
    this.selectElement.dispatchEvent(changeEvent);
  }
}

customElements.define('custom-dropdown', CustomDropdown);